import React from "react"
import "./styles.scss"

import Header from "../../../../components/Header"
import Footer from "../../../../components/Footer"
import InfoDashboard, {
  InfoDashboardItem,
  InfoDashboardTitle,
  InfoDashboardDescription
} from "../../components/InfoDashboard"
import Button from "../../../../components/Button"

const Welcome = () => {
  return (
    <div className="main-container main-container--dark">
      <Header theme="light" hideNotifications />

      <div className="content welcome">
        <div className="content_section_header">
          <div className="container">
            <div className="row">
              <div className="col-md-6 offset-md-3">
                <h1 className="content_section_title">
                  Creating Your Support Pre-Plan Can Take Awhile To Complete,
                  You Can Always Come Back And Start Where You Left Off.
                </h1>

                <div className="content_section_description">
                  Developing your pre-plan will take time. It does not have to
                  be completed at the first attempt. Content that you enter into
                  the various areas will be saved. You can return at any time
                  and continue with your pre-planning. Once completed you will
                  have a comprehensive pre-plan which can be shared with your
                  Local Area Coordinator for further input.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-md-6 offset-md-3">
              <InfoDashboard>
                <InfoDashboardItem>
                  <InfoDashboardTitle>About Me</InfoDashboardTitle>
                  <InfoDashboardDescription>
                    In this section you identify people (your Support Team) who
                    can help you develop your pre-plan. You will also be asked
                    to provide information about your current living situation,
                    daily life, things that are important, health, safety,
                    communication, education, employment and your involvement in
                    any community activities.
                  </InfoDashboardDescription>
                </InfoDashboardItem>

                <InfoDashboardItem>
                  <InfoDashboardTitle>Setting Goals</InfoDashboardTitle>
                  <InfoDashboardDescription>
                    In this section you will define what you are aiming to
                    achieve and what supports and structure you require to
                    achieve your goals. Working closely with your Support Team
                    to explore your goals will be of value.
                  </InfoDashboardDescription>
                </InfoDashboardItem>

                <InfoDashboardItem>
                  <InfoDashboardTitle>Required Services</InfoDashboardTitle>
                  <InfoDashboardDescription>
                    In this section you identify the services and equipment you
                    need to help you achieve your goals. Additional detail on
                    these services will help your Local Area Coordinator and
                    Planner refine your support plan at a later stage.
                  </InfoDashboardDescription>
                </InfoDashboardItem>

                <InfoDashboardItem>
                  <InfoDashboardTitle>Review</InfoDashboardTitle>
                  <InfoDashboardDescription>
                    Before you complete your plan you can review what you have
                    written. You can also have your plan reviewed by your
                    Support Team. At this stage, you can still edit your
                    pre-plan to improve it further. When you are satisfied with
                    your pre-plan, you can click the “Finish” button.
                    Congratulations.
                  </InfoDashboardDescription>
                </InfoDashboardItem>
              </InfoDashboard>
              <Button
                routerLink={{
                  to: "/pre-plan/support-team"
                }}
                className="btn--secondary-light btn--width-full btn--height-lg btn--font-size-sm"
              >
                I’m Ready To Start Building My Pre-Plan
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Welcome
